import { useContext, useState } from 'react'
import ShoppingCartContext from './ShoppingCartContext'
import { Avatar, Button, Card, CardContent, CircularProgress, Stack, Typography, useTheme } from '@mui/material'
import { CategoryOutlined, LocalShippingOutlined, ReceiptLongOutlined, PendingActionsOutlined } from '@mui/icons-material'
import { PendingPayItem, DeliveryItem, ProductItem, WaybillItem, ItemCollapse } from './ShoppingCartSharedComponents'
import { downloadTicket } from '../../Shared'
import DownloadButton from '../../Shared/DownloadButton'

export default function BuyResume() {
  const { carts, actualCart, replicateCart } = useContext(ShoppingCartContext)
  const cart = carts[actualCart]
  const localhost = sessionStorage.getItem('localhost')
  const token = sessionStorage.getItem('token')
  const userPermissions = JSON.parse(sessionStorage.getItem('permissions'))

  const [downloadingWaybills, setDownloadingWaybills] = useState(false)
  const [downloadingTicket, setDownloadingTicket] = useState(false)

  const [loadingReplication, setLoadingReplication] = useState(false)

  async function createOtherCart() {
    try {
      setLoadingReplication(true)
      // Use the current cart's customer information to create a new cart
      const customerInfo = cart?.costumer || {}

      await replicateCart(customerInfo, cart)
    } catch (error) {
      console.error('Error creating a new cart:', error)
    } finally {
      setLoadingReplication(false)
    }
  }
  async function downloadWaybill() {
    try {
      setDownloadingWaybills(true)

      const waybills = cart.response.waybills.waybillsGenerated.map(waybill => waybill.numero)

      const request = await fetch(`${localhost}/api/v2/waybills/download?waybills=${JSON.stringify(waybills)}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`
        }
      })

      if (request.ok === true) {
        const blob = await request.blob()
        const url = URL.createObjectURL(blob)
        const anchor = document.createElement('a')

        anchor.href = url
        anchor.download = `${cart.response.ticket}.zip`
        anchor.click()

        URL.revokeObjectURL(url)

        return
      }

      throw new Error('Ocurrió un error con la petición')
    } catch (error) {
      console.error(error.message)
    } finally {
      setDownloadingWaybills(false)
    }
  }

  return (
    <Stack spacing={2}>
      <Typography variant='body1'>Tu compra ha sido completada.</Typography>

      {cart?.response?.waybills.isNull === undefined && (
        <Section
          title='Guías'
          icon={<ReceiptLongOutlined sx={{ fontSize: 18 }} />}
          spacing={2}
        >
          <Stack>
            {cart?.response?.waybills.waybillsGenerated && (
              <Stack>
                <Typography variant='subtitle1'>Guías Generadas</Typography>
                {cart?.response.waybills.waybillsGenerated.map((waybill, idx) => (
                  <Stack
                    key={idx}
                    direction='row'
                    justifyContent='space-between'
                    alignItems='center'
                  >
                    <ItemCollapse
                      data={waybill}
                      isDeletable={false}
                      type='waybills'
                    />
                  </Stack>
                ))}
              </Stack>
            )}

            {cart?.response?.waybills.waybillsWithErrors && (
              <Stack>
                <Typography variant='subtitle1'>Guías con errores</Typography>

                {cart?.response.waybills.waybillsWithErrors.map((waybill, idx) => (
                  <DeliveryItem
                    key={idx}
                    data={waybill.waybill}
                  />
                ))}
              </Stack>
            )}
          </Stack>
        </Section>
      )}

      {cart?.response?.products.isNull === undefined && (
        <Section
          title='Productos'
          icon={<CategoryOutlined sx={{ fontSize: 18 }} />}
          spacing={2}
        >
          {cart?.response?.products.productsGenerated && (
            <Stack>
              <Typography variant='subtitle1'>Productos Generados</Typography>

              {cart?.response.products?.productsGenerated?.map((product, idx) => (
                <ProductItem
                  key={idx}
                  data={product}
                />
              ))}
            </Stack>
          )}

          {cart?.response?.products.productsWithErrors && (
            <Stack>
              <Typography variant='subtitle1'>Productos con errores</Typography>

              {cart?.response?.products?.productsWithErrors?.map((product, idx) => (
                <ProductItem
                  key={idx}
                  data={product.product}
                />
              ))}
            </Stack>
          )}
        </Section>
      )}

      {cart?.response?.deliveries.isNull === undefined && (
        <Section
          title='Entregas'
          icon={<LocalShippingOutlined sx={{ fontSize: 18 }} />}
          spacing={2}
        >
          {cart?.response?.deliveries.deliveriesGenerated && (
            <Stack>
              <Typography variant='subtitle1'>Entregas generadas</Typography>

              {cart?.response?.deliveries.deliveriesGenerated.map((delivery, idx) => (
                <DeliveryItem
                  key={idx}
                  data={delivery}
                />
              ))}
            </Stack>
          )}

          {cart?.response?.deliveries.deliveriesWithErrors && (
            <Stack>
              <Typography variant='subtitle1'>Entregas con errores</Typography>

              {cart?.response.deliveries.deliveriesWithErrors.map((delivery, idx) => (
                <DeliveryItem
                  key={idx}
                  data={delivery.delivery}
                />
              ))}
            </Stack>
          )}
        </Section>
      )}

      {cart?.response?.pendingPays?.isNull === undefined && (
        <Section
          title='Tickets pendientes de pago'
          icon={<PendingActionsOutlined sx={{ fontSize: 18 }} />}
          spacing={2}
        >
          {cart?.response.pendingPays?.ticketsUpdated && (
            <Stack>
              <Typography variant='subtitle1'>Tickets actualizados</Typography>

              {cart?.response.pendingPays.ticketsUpdated.map((pendingPay, idx) => (
                <PendingPayItem
                  key={idx}
                  data={pendingPay}
                  isDownloadable={false}
                />
              ))}
            </Stack>
          )}

          {cart?.response?.pendingPays?.ticketsWithErrors && (
            <Stack>
              <Typography variant='subtitle1'>Tickets con errores</Typography>

              {cart?.response.pendingPays?.ticketsWithErrors.map((pendingPay, idx) => (
                <PendingPayItem
                  key={idx}
                  data={pendingPay.pendingPay}
                  isDownloadable={false}
                />
              ))}
            </Stack>
          )}
        </Section>
      )}

      {/* {cart.response.waybills.isNull === undefined && (
        <Section
          title='Pagos pendientes'
          icon={<ReceiptLongOutlined sx={{ fontSize: 18 }} />}
          spacing={2}
        >
          <Stack>
            {cart.response.waybills.waybillsGenerated && (
              <Stack>
                <Typography variant='subtitle1'>Guías generadas</Typography>
                {cart.response.waybills.waybillsGenerated.map(waybill => (
                  <Stack
                    direction='row'
                    justifyContent='space-between'
                    alignItems='center'
                  >
                    <WaybillItem data={waybill} />
                    <DownloadButton
                      waybill={waybill.numero}
                      token={token}
                      localhost={localhost}
                    />
                  </Stack>
                ))}
              </Stack>
            )}

            {cart.response.waybills.waybillsWithErrors && (
              <Stack>
                <Typography variant='subtitle1'>Guías con errores</Typography>

                {cart.response.waybills.waybillsWithErrors.map(waybill => (
                  <DeliveryItem data={waybill.waybill} />
                ))}
              </Stack>
            )}
          </Stack>
        </Section>
      )} */}

      <Stack
        useFlexGap
        direction='row'
        flexWrap='wrap'
        spacing={2}
      >
        {cart?.response?.waybills.waybillsGenerated !== undefined && cart?.response?.waybills.waybillsGenerated > 1 && (
          <Button
            variant='outlined'
            disabled={downloadingWaybills === true}
            startIcon={downloadingWaybills === true ? <CircularProgress size={20} /> : null}
            onClick={() => downloadWaybill()}
          >
            Descargar guías generadas
          </Button>
        )}

        {(userPermissions['role'] !== 'SubCliente' || (cart?.response?.waybills?.waybillsGenerated !== null && cart?.response?.deliveries?.deliveriesGenerated !== null && cart?.response?.products?.productsGenerated !== null && cart?.response?.pendingPays?.ticketsUpdated !== null)) && (cart?.response?.waybills?.waybillsGenerated?.length > 0 || cart?.response?.deliveries?.deliveriesGenerated?.length > 0 || cart?.response?.products?.productsGenerated?.length > 0 || cart?.response?.pendingPays?.ticketsUpdated?.length > 0) && (
          <>
            <Button
              variant='outlined'
              disabled={downloadingTicket === true}
              startIcon={downloadingTicket === true ? <CircularProgress size={20} /> : null}
              onClick={() => downloadTicket(setDownloadingTicket, cart.response.ticket)}
            >
              Imprimir ticket
            </Button>
            {(cart?.response?.waybills?.waybillsGenerated?.length > 0 || cart?.response?.deliveries?.deliveriesGenerated?.length > 0) && (
              <DownloadButton
                type='manifest'
                identifier={cart.response.ticket}
              />
            )}
          </>
        )}
        {(cart?.response?.waybills.waybillsWithErrors || cart?.response?.deliveries.deliveriesWithErrors || cart?.response?.pendingPays?.ticketsWithErrors) && (
          <Button
            variant='outlined'
            onClick={createOtherCart}
            disabled={loadingReplication}
          >
            Replicar Carrito
          </Button>
        )}
      </Stack>
    </Stack>
  )
}

// const DownloadButton = ({ waybill, localhost, token }) => {
//   const [downloading, setDownloading] = useState(false)

//   async function downloadWaybill() {
//     try {
//       setDownloading(true)

//       const request = await fetch(`${localhost}/api/v2/waybills/download/${waybill}`, {
//         method: 'GET',
//         headers: {
//           Authorization: `Bearer ${token}`
//         }
//       })

//       if (request.ok === true) {
//         const blob = await request.blob()
//         const url = URL.createObjectURL(blob)
//         const anchor = document.createElement('a')

//         anchor.href = url
//         anchor.download = `${waybill}.pdf`
//         anchor.click()

//         URL.revokeObjectURL(url)

//         return
//       }

//       throw new Error('Ocurrió un error con la petición')
//     } catch (error) {
//       console.error(error.message)
//     } finally {
//       setDownloading(false)
//     }
//   }

//   if (downloading) {
//     return <CircularProgress size={20} />
//   } else {
//     return (
//       <IconButton onClick={() => downloadWaybill()}>
//         <DownloadOutlined />
//       </IconButton>
//     )
//   }
// }

const Section = ({ icon, title, children, spacing }) => {
  const theme = useTheme()

  return (
    <Card
      variant='outlined'
      sx={{ height: '100%' }}
    >
      <CardContent>
        <Stack spacing={1}>
          <Stack
            direction='row'
            spacing={1}
            alignContent='center'
          >
            <Avatar sx={{ width: 28, height: 28, backgroundColor: theme.palette.primary.main }}>{icon}</Avatar>
            <Typography variant='subtitle1'>{title}</Typography>
          </Stack>
          <Stack spacing={spacing ?? 0}>{children}</Stack>
        </Stack>
      </CardContent>
    </Card>
  )
}
